// frontend/src/services/socket.js
// Responsibility: Export a configured Socket.IO client.

import { io } from 'socket.io-client';
import store from '../store';                       // adjust if your store export is named
import { upsertDriver } from '../features/drivers/driverSlice';

const socket = io({ path: '/socket.io', transports: ['websocket'] });

// Backend emits both of these in your controller:
socket.on('driver:photoUpdated', ({ driver }) => {
  if (driver) store.dispatch(upsertDriver(driver));
});
socket.on('driverUpdated', (payload) => {
  const driver = payload?.driver ?? payload;       // some emits send raw driver
  if (driver) store.dispatch(upsertDriver(driver));
});

export default socket;
